import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "@/features/utils/i18n";
import { EnvelopeIcon } from "@phosphor-icons/react";

/**
 * What stands in for the checklist on a SIP request.
 *
 * There is nothing to upload here — no number is created or moved, so there is
 * no carrier file. What the request needs is a technical conversation, and the
 * worst outcome would be a client staring at an empty documents card wondering
 * what they're missing. So the empty state is replaced by an explicit "here is
 * what happens next, and it happens by e-mail", plus the list of details worth
 * putting in the description field so the first reply can be useful.
 */
const EXPECTED_DETAILS = ["pbx", "trunk", "numbers", "volume"] as const;

export function SipPanel() {
  const { t } = useTranslation("numberRequests");

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("numberRequests.sip.title")}</CardTitle>
        <p className="text-muted-foreground text-sm">
          {t("numberRequests.sip.intro")}
        </p>
      </CardHeader>

      <CardContent className="space-y-4">
        <div className="bg-muted/50 flex items-start gap-3 rounded-lg border p-3">
          <EnvelopeIcon className="text-primary mt-0.5 h-5 w-5 shrink-0" />
          <div className="space-y-1">
            <p className="text-sm font-medium">
              {t("numberRequests.sip.contactTitle")}
            </p>
            <p className="text-muted-foreground text-sm">
              {t("numberRequests.sip.contactBody")}
            </p>
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-sm font-medium">
            {t("numberRequests.sip.detailsTitle")}
          </p>
          <ul className="text-muted-foreground list-inside list-disc space-y-1 text-sm">
            {EXPECTED_DETAILS.map((detail) => (
              <li key={detail}>{t(`numberRequests.sip.details.${detail}`)}</li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
}
